import {
	DialogRoot,
	DialogPortal,
	DialogOverlay,
	DialogTrigger,
	DialogClose,
	DialogContent,
	DialogHeader,
	DialogFooter,
	DialogTitle,
	DialogDescription
} from './Dialog';

export const Dialog = {
	Root: DialogRoot,
	Portal: DialogPortal,
	Overlay: DialogOverlay,
	Trigger: DialogTrigger,
	Close: DialogClose,
	Content: DialogContent,
	Header: DialogHeader,
	Footer: DialogFooter,
	Title: DialogTitle,
	Description: DialogDescription
};
